import React, { Component } from 'react'
import { Modal, ModalBody } from 'reactstrap'

const SOURCING_URL = 'https://genhavensourcing.co.uk/';
const SEEN_KEY = 'sourcingPopupSeen';

export default class SourcingPopup extends Component {
	constructor(props) {
		super(props);
		let seen = false;
		try {
			seen = sessionStorage.getItem(SEEN_KEY) === '1';
		} catch (e) { }
		this.state = { isOpen: !seen };
	}

	close = () => {
		try {
			sessionStorage.setItem(SEEN_KEY, '1');
		} catch (e) { }
		this.setState({ isOpen: false });
	}

	render() {
		return (
			<Modal isOpen={this.state.isOpen} toggle={this.close} centered>
				<ModalBody className="text-center p-4">
					<button type="button" className="btn-close position-absolute top-0 end-0 m-3" aria-label="Close" onClick={this.close}></button>
					<h3 className="mb-3">Welcome to GenHaven!</h3>
					<p className="mb-4">For our latest updates and services, please visit GenHaven Sourcing.</p>
					<a href={SOURCING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary" onClick={this.close}>Visit GenHaven Sourcing</a>
				</ModalBody>
			</Modal>
		)
	}
}
